/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Metrics from 'services/metrics';

import { showModal, setScreen } from '../../actions';
import IconProfile from '../../../_Shared/IconProfile';
import './menuswitch.scss';


const ProfileElement = ({ userImage, username, partnerUserId, changeUser }) => (
  <li className="menu--profile--container">
    <span
      className="menu--profile--container--opt"
      href="#"
      onClick={changeUser}
      id={partnerUserId}
    >
      <IconProfile src={userImage} />
      <span>
        {username.length <= 15 ? username : `${username.slice(0, 12)}...`}
      </span>
    </span>
  </li>
);

ProfileElement.propTypes = {
  userImage: PropTypes.string,
  username: PropTypes.string,
  partnerUserId: PropTypes.string,
  changeUser: PropTypes.func,
};

const MenuSwitch = ({ onSwitchProfile, admin }) => {
  const manageProfilesText = 'Administrar perfiles';
  const dispatch = useDispatch()
  const members = useSelector(state => state?.profiles?.profile?.data?.members);
  const {user_id: userId} = useSelector(state => state?.user) || {};

  const adminUserId = members?.find(member => member?.admin === true)?.partnerUserId || ''; 

  const changeUser = (user_hash) => {
    Metrics.newEvent({
      eventCategory: 'Top Menu',
      eventAction: 'Click',
      eventLabel: 'Click',
    });
    onSwitchProfile(user_hash);
  };

  const showModalHandle = () => {
    dispatch(setScreen({ modal: 'manage' }))
    dispatch(showModal({ show: true }))
    Metrics.newEvent({
      eventCategory: 'Top Menu',
      eventAction: 'Click',
      eventLabel: 'Perfil',
      PID: `${userId}${adminUserId}`,
      UID: adminUserId,
    });
  };

  return (
    <ul className="menu--profile--list">
      {members && (
        <div className="menu--profile--container--wrapper">
          {members?.map(user => (
            <ProfileElement
              userImage={user.user_image}
              username={user.username}
              partnerUserId={user.partnerUserId}
              changeUser={() => changeUser(user.user_hash)}
              key={user.partnerUserId}
            />
          ))}
        </div>
      )}
      {admin && members?.length && (
        <li className="menu--profile--manage">
          <a href="#" onClick={showModalHandle} className='menu--perfil--manage-text' >
            {manageProfilesText}
          </a>
        </li>
      )}
    </ul>
  );
}

export default MenuSwitch;
